import TableSearch from '@rio-cloud/rio-uikit/TableSearch';

type SearchInputProps = {
    id?: string;
    value: string;
    onSearch: (value: string) => void;
    placeholder?: string;
    ariaLabel?: string;
};

export const SearchInput = ({ id, value, onSearch, placeholder = 'Search', ariaLabel }: SearchInputProps) => {
    return <TableSearch id={id} aria-label={ariaLabel} placeholder={placeholder} value={value} onChange={onSearch} />;
};
